module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-creative-bottom-01.1.9ff58285.jpg";